import { Service } from '../mainService'
import { FiltrosEnviosSM } from '@/types/administracao/filtros-envios-sem-movimento'
import { EnviosSM } from '@/types/administracao/envios-sm';

const enviosSMService = {
    buscarSistemas,
    buscarEnviosSM,
    removerEnviosSM,
    adicionarEnviosSM,
}

async function adicionarEnviosSM(envio: EnviosSM) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_ENTREGAS_API + "/PCM/autorizacaoSemMovimento", envio.toFormData());
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarEnviosSM(filtros: FiltrosEnviosSM, page: number) {
    try {
        const parametros = `?page=${page}&pageSize=10${filtros.toQueryString()}`
        const response = Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCM/autorizacaoSemMovimento" + parametros);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarSistemas() {
    try {
        const response = Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCM/sistemas");
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerEnviosSM(id: number) {
    try {
        const response = Service.$http.delete(process.env.VUE_APP_ENTREGAS_API + "/PCM/autorizacaoSemMovimento?idAutorizacao=" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

export default enviosSMService;